//hook
import { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";

//image
import roomImage from "../../assets/images/home_image/gallary.jpg"

//css file
import style from "../Rooms/Rooms.module.css"

//translate
import i18n from "../../translate/i18n";
import { useTranslation } from 'react-i18next';

//material ui
import { Box } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';

//component
import GalleryCard from "../../Component/GalleryCard";

//api
import { GetGallery } from "../../api/gallery/GetGallery";

//type
import { galleryType } from "../../api/gallery/type/GalleryType";

const GalleryPage = () => {
  const { t } = useTranslation();
  let [gallerySection, setGallerySection] = useState<galleryType[]>();
  const {
    loading: galleryLoading,
    error: galleryError,
    HandlerApi: galleryApi
  } = useApi(GetGallery, "GET");

  useEffect(() => {
    const fetchData = async () => {
      const gallerySection = await galleryApi(null);
      setGallerySection(gallerySection.data);
      };
    fetchData();
    }, []);

  return (
      <div dir={i18n.language === "en" ? "ltr" : "rtl"} className={`${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} bg-[#EDEBDF] py-10 mt-10 text-primaryColor`}>
        <div className={`h-[500px] max-md:h-72 relative image ${style.image}`}>
            <img className="w-full h-full object-cover" src={roomImage} alt="no_photo"/>
            <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 translate-y-1/2 text-white md:text-2xl sm:text-sm max-sm:text-[13px]">{t("gallery")}</p>
        </div>
        <Box sx={{padding: {md: "40px", xs: "20px"}}} className="max-w-[1560px] m-auto gap-[10px]  text-center">
          {/* <h2 className="sm:text-5xl max-sm:text-2xl mb-4 text-primaryColor">
              {t("gallerys_photo")}
          </h2>
          <p className="max-w-[600px] mb-4 m-auto">{t("gallery_description")}</p> */}
          {galleryLoading 
            ? 
            <div className='flex justify-center w-full'>
              <CircularProgress/>
            </div>
            :
            galleryError
            ?
            <div className='cursor-pointer flex justify-center w-full'>
              <ReplayIcon onClick={()=> galleryApi(null)} className='!text-[40px]' />
            </div>
            :
            <>
                {gallerySection?.map((element, index) =>{
                  return (
                    <div>
                      <h2 className="sm:text-5xl max-sm:text-2xl m-10">{element.title}</h2>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {element.images.map((item, index)=>{
                          return (
                            <GalleryCard key={index} item={item}/>
                          );
                        })}
                      </div>
                    </div>
                  );
                }
                )}
            </>
          }
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {/* {Gallerys.imagesGallery.map((element, index) =>{
              return (
                <GalleryCard key={index} element={element}/>
              );
            }
            )} */}
          </div>
        </Box>
      </div>
  )
}

export default GalleryPage
